import { FileItemRef } from '@nhost/nhost-js';
import { createContext, ReactNode, useContext } from 'react';

import { UploadFileCardActionsFactory, UploadFileCardIcon, UploadFileCardProps } from '../cards';
import { UploadedFile } from './shared';

export interface FileInputContext<T extends UploadedFile = UploadedFile> {
  isMulti?: boolean;
  /** Shows the files without taking new ones or offering delete and re-upload; a ComplyKit Field has no form context to say so. */
  isReadOnly?: boolean;
  uploadedFiles?: T[];
  onUploadedFileDownload?: (fileId: string) => void;
  onUploadedFileDelete?(file: T): Promise<void>;
  onUploadedFileReupload?(file: T, files: File[]): Promise<void>;
  stagedFiles?: FileItemRef[];
  icon?: UploadFileCardIcon;
  actions?: UploadFileCardActionsFactory;
  getUploadedFileWarning?(file: T): string | undefined;
  renderUploadedFile?(props: UploadFileCardProps & { file: T }): ReactNode;
  onStagedFilesAdd?: (files: File[]) => void;
  onStagedFileDelete?: (fileId: string, file: File) => void;
  registerReuploadCb(cb: (file: T) => void): () => void;
  handleFileReupload(file: T): void;
}

export const FileInputContext = createContext<FileInputContext | null>(null);

export function useFileInputContext() {
  const context = useContext(FileInputContext);

  if (!context) {
    throw new Error('FileUpload components must be wrapped in <FileUpload />');
  }

  return context;
}
